<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-blurbs element-with-heading" id="blurbs">
<div class="heading heading-with-title heading-without-image" id="blurbs-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for Joanna Stephen -Ward</h1>
</div>
</div>
</div>
</div>
<div class="text" id="blurbs-text">
<p class="first first-in-chapter first-full-width"><i>I really enjoyed this book,had me gripped from beginning to end. A must read, I didn't want this book to end.</i></p>
<p class="subsq"><b><i>Karen S – Amazon Reviewer</i></b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-193">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out-copy.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width"><i>Best book I have read in a long time.</i></p>
<p class="subsq"><i>This author is fantastic. I couldn't wait to see what happened next. What a brilliant ending too. I can't praise this book enough. Loved all the characters.....except Gloria of course ... but I did feel sorry for her too. What a good book. 5 stars for sure xx</i></p>
<p class="subsq"><b><i>Kylee – Amazon Reviewer</i></b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-193">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out-copy.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width"><i>Great read, couldn’t put it down. Character depth was brilliant and the story built nicely to a unexpected ending. Will look for more by this Author.</i></p>
<p class="subsq"><b><i>Amazon Customer</i></b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-193">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out-copy.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width"><i>The Doll Collector exceeded all my expectations. It's different, it has some dry humour in it and I couldn't put it down. I read about 85% of it in one sitting. I loved it.</i></p>
<p class="subsq"><b><i>Nicola in South Yorkshire – Amazon Top 1000 Reviewer</i></b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-193">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out-copy.jpg"/>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise-for-joanna-stephen--ward.vue?2e64da6b